import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api';

function LoginPage() {
  const [tab, setTab] = useState('login');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const [loginData, setLoginData] = useState({ email: '', password: '' });
  const [regData, setRegData] = useState({ name: '', company: '', email: '', phone: '', password: '' });

  const handleLogin = async () => {
    setError(''); setLoading(true);
    try {
      await authApi.login(loginData.email, loginData.password);
      navigate('/cabinet');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async () => {
    setError(''); setLoading(true);
    try {
      await authApi.register(regData);
      setSuccess('Реєстрація успішна! Очікуйте підтвердження від менеджера.');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const s = {
    page: { minHeight: '100vh', background: '#F8F6F0', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 20px' },
    box: { background: '#fff', borderRadius: 16, padding: 48, width: '100%', maxWidth: 440, border: '1px solid #E2DECE' },
    title: { fontFamily: 'Georgia, serif', fontSize: 28, fontWeight: 700, marginBottom: 8, color: '#0D1B2A' },
    sub: { fontSize: 14, color: '#6B7280', marginBottom: 32 },
    tabs: { display: 'flex', gap: 4, marginBottom: 32, borderBottom: '2px solid #E2DECE' },
    tab: (active) => ({ padding: '10px 24px', background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: active ? 600 : 400, color: active ? '#0D1B2A' : '#6B7280', borderBottom: active ? '2px solid #C9A84C' : '2px solid transparent', marginBottom: -2 }),
    label: { display: 'block', fontSize: 13, fontWeight: 500, color: '#0D1B2A', marginBottom: 6 },
    input: { width: '100%', padding: '12px 16px', border: '1px solid #E2DECE', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box', marginBottom: 16, fontFamily: 'Inter, sans-serif' },
    btn: { width: '100%', padding: '14px', background: '#0D1B2A', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 8 },
    error: { background: '#FEE2E2', color: '#991B1B', padding: '12px 16px', borderRadius: 8, fontSize: 13, marginTop: 16 },
    success: { background: '#D1FAE5', color: '#065F46', padding: '12px 16px', borderRadius: 8, fontSize: 13, marginTop: 16 },
  };

  return (
    <div style={s.page}>
      <div style={s.box}>
        <h2 style={s.title}>Особистий кабінет</h2>
        <p style={s.sub}>Вхід для зареєстрованих оптових клієнтів</p>

        <div style={s.tabs}>
          <button style={s.tab(tab === 'login')} onClick={() => { setTab('login'); setError(''); setSuccess(''); }}>Увійти</button>
          <button style={s.tab(tab === 'register')} onClick={() => { setTab('register'); setError(''); setSuccess(''); }}>Реєстрація</button>
        </div>

        {tab === 'login' && (
          <div>
            <label style={s.label}>Email</label>
            <input style={s.input} type="email" placeholder="mail@company.ua" value={loginData.email} onChange={e => setLoginData({...loginData, email: e.target.value})} />
            <label style={s.label}>Пароль</label>
            <input style={s.input} type="password" placeholder="••••••••" value={loginData.password} onChange={e => setLoginData({...loginData, password: e.target.value})}
              onKeyDown={e => e.key === 'Enter' && handleLogin()} />
            <button style={s.btn} onClick={handleLogin} disabled={loading}>
              {loading ? 'Завантаження...' : 'Увійти'}
            </button>
          </div>
        )}

        {tab === 'register' && (
          <div>
            <label style={s.label}>Ім'я *</label>
            <input style={s.input} placeholder="Іван Петренко" value={regData.name} onChange={e => setRegData({...regData, name: e.target.value})} />
            <label style={s.label}>Компанія</label>
            <input style={s.input} placeholder="ТОВ «Ваша Компанія»" value={regData.company} onChange={e => setRegData({...regData, company: e.target.value})} />
            <label style={s.label}>Email *</label>
            <input style={s.input} type="email" placeholder="mail@company.ua" value={regData.email} onChange={e => setRegData({...regData, email: e.target.value})} />
            <label style={s.label}>Телефон</label>
            <input style={s.input} type="tel" placeholder="+380 XX XXX XX XX" value={regData.phone} onChange={e => setRegData({...regData, phone: e.target.value})} />
            <label style={s.label}>Пароль *</label>
            <input style={s.input} type="password" placeholder="Мінімум 8 символів" value={regData.password} onChange={e => setRegData({...regData, password: e.target.value})} />
            <button style={s.btn} onClick={handleRegister} disabled={loading}>
              {loading ? 'Завантаження...' : 'Зареєструватись'}
            </button>
            {success && <div style={s.success}>{success}</div>}
          </div>
        )}

        {error && <div style={s.error}>{error}</div>}
      </div>
    </div>
  );
}

export default LoginPage;
